import { jsx } from 'react/jsx-runtime';
import { classNames } from '../../utils/functions/classNames/classNames.js';

const ModalCard = ({ children, borderRadius = 'default', dataTestId, }) => (jsx("div", { "data-testid": dataTestId, className: classNames('modal-card', {
        'modal-card__radius-small': borderRadius === 'small',
    }), children: children }));

export { ModalCard };
